import {useMemo, useEffect} from "react";
import {useForm} from "react-hook-form";
import {navigate} from "vike/client/router";
import {usePageContext} from "vike-react/usePageContext";

import FormField from "@/components/common/FormField";
import countryData from "@/data/country.json";
import type {Country} from "@/types/clinic";


const typedCountryData = countryData as Record<string, Country>;

export default function ClinicSearchForm() {
  const pageContext = usePageContext();
  const {country: countrySlug, region: regionSlug} = pageContext.routeParams;

  const {control, watch, setValue} = useForm({
    defaultValues: {
      country: countrySlug || "",
      region: "",
    },
  });

  const selectedCountry = watch("country");
  const selectedRegion = watch("region");

  useEffect(() => {
    if (countrySlug && typedCountryData[countrySlug]) {
      setValue("country", countrySlug);

      if (regionSlug && regionSlug !== "all" && typedCountryData[countrySlug].regions && typedCountryData[countrySlug].regions[regionSlug]) {
        setValue("region", regionSlug);
      } else if (!regionSlug || regionSlug === "all") {
        setValue("region", "");
      }
    } else {
      setValue("country", "");
      setValue("region", "");
    }
  }, [countrySlug, regionSlug, setValue]);

  useEffect(() => {
    if (selectedCountry && selectedCountry !== countrySlug) {
      setValue("region", "");
    }
  }, [selectedCountry, setValue, countrySlug]);

  const countryOptions = useMemo(
    () =>
      Object.entries(typedCountryData).map(([key, {name}]) => ({
        id: key,
        value: key,
        label: name,
      })),
    [],
  );

  const regionOptions = useMemo(() => {
    const regions = typedCountryData[selectedCountry]?.regions;
    if (!regions) return [];

    const options = Object.entries(regions).map(([key, {name}]) => ({
      id: key,
      value: key,
      label: name,
    }));
    return options;
  }, [selectedCountry]);

  const handleSearch = () => {

    if (selectedCountry && selectedRegion) {
      navigate(`/clinics/${selectedCountry}/${selectedRegion}`);
    } else if (selectedCountry) {
      navigate(`/clinics/${selectedCountry}`);
    }
  };

  return (
    <div className="container -countriesList-selection">
      <div className="row">
        <div className="col-md-5 col-12">
          <FormField
            label=""
            name="country"
            control={control}
            type="select"
            className=""
            options={countryOptions}
            placeholder="Select a Country"
            inputClassName="-xlg"
          />
        </div>
        <div className="col-md-5 col-12">
          <FormField
            label=""
            name="region"
            control={control}
            type="select"
            options={regionOptions}
            placeholder="Please select a region"
            className=""
            inputClassName="-xlg"
            disabled={!selectedCountry}
          />
        </div>
        <div className="col-md-2 col-12">
          <button
            className="btn btn-outline-primary custom-input-button"
            onClick={handleSearch}
          >
            Find Clinics
          </button>
        </div>
      </div>
    </div>
  );
}
